import humanizeDuration from 'humanize-duration';
export const shortHumanizer = humanizeDuration.humanizer({
  language: 'short',
  units: ['y', 'mo', 'd', 'h', 'm', 's'],
  // no weeks or milliseconds
  languages: {
    short: {
      y: () => 'y',
      mo: () => 'mo',
      d: () => 'd',
      h: () => 'h',
      m: () => 'm',
      s: () => 's'
    }
  }
});